import { hostDocument } from '../../shared/host_window';

// Whether the host is out of reach (utils/visible_slice explains the case).
export const isForeignEmbed = () => hostDocument() === null;

// Where the overlays (mobile sheet, toast, cut line confirmation) render: the
// host document when it is ours, so `position: fixed` and `dvh` resolve
// against the browser viewport; the frame's own body otherwise.
export const getTopPortalTarget = () => {
  const topDoc = hostDocument();
  if (!topDoc) return document.body;

  return topDoc.getElementById("modal-root") || topDoc.body;
};
